export const ADDRESS_SEARCH_DEBOUNCED_DELAY_IN_MS = 900;
